module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/gents-club-5ceee58a129b555c069d5efe362f3cdb.jpg";